package presentation.screens.profile

import com.kinoshazam.model.AppLanguage
import com.kinoshazam.model.Features
import com.kinoshazam.model.ThemeState
import models.User
import utils.UiAction
import utils.UiState

sealed interface ProfileMVIAction : UiAction {

    data object LogoutClicked : ProfileMVIAction
    data object MenuClosed : ProfileMVIAction
    data object OpenThemeMenu : ProfileMVIAction
    data object OpenLanguageMenu : ProfileMVIAction
    data object CloseMenu : ProfileMVIAction
    data class LanguageChanged(val language: AppLanguage) : ProfileMVIAction
    data class ThemeSelected(val theme: ThemeState) : ProfileMVIAction
    data object BackPressed : ProfileMVIAction
    data object LoginPressed : ProfileMVIAction
    data object UpdateClicked : ProfileMVIAction
    data object AppInfoClicked : ProfileMVIAction
    data object OpenHistory : ProfileMVIAction
}

data class ProfileState(
    val isLoading: Boolean = false,
    val isError: Boolean = false,
    val bottomSheetState: BottomSheetState = BottomSheetState.Closed,
    val themeState: ThemeState,
    val appLanguage: AppLanguage,
    val features: Features,
    val user: User? = null,
    val updateAvailable: Boolean = false,
    val updateVersionName: String? = null,
    val forceUpdate: Boolean = false,
) : UiState {

    sealed interface BottomSheetState {

        data object ThemeMenu : BottomSheetState
        data object LanguageMenu : BottomSheetState
        data object Closed : BottomSheetState
    }
}